import cn from 'classnames'
import React, { ComponentProps } from 'react'

type SavedViewsIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function SavedViewsIcon(props: SavedViewsIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('SavedViewsIcon', className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M5.83268 10.0001L1.66602 12.0835L9.70121 16.1011C9.81052 16.1557 9.86518 16.1831 9.92252 16.1938C9.9733 16.2033 10.0254 16.2033 10.0762 16.1938C10.1335 16.1831 10.1882 16.1557 10.2975 16.1011L18.3327 12.0835L14.166 10.0001M1.66602 7.9168L9.70121 3.89921C9.81052 3.84455 9.86518 3.81722 9.92252 3.80646C9.97329 3.79693 10.0254 3.79693 10.0762 3.80646C10.1335 3.81722 10.1882 3.84455 10.2975 3.89921L18.3327 7.9168L10.2975 11.9344C10.1882 11.9891 10.1335 12.0164 10.0762 12.0271C10.0254 12.0367 9.97329 12.0367 9.92252 12.0271C9.86518 12.0164 9.81052 11.9891 9.70121 11.9344L1.66602 7.9168Z"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
